import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { MONTHS_ES } from "./shared";

export const currentYm = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const shiftYm = (ym, delta) => {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export default function PeriodPicker({ value, onChange, periods = [], testid = "mr-period", compact }) {
  const [y, m] = value.split("-").map(Number);
  const nowY = new Date().getFullYear();
  const years = new Set([nowY, nowY - 1, y]);
  periods.forEach((p) => years.add(Number(p.slice(0, 4))));
  const yearList = [...years].filter(Boolean).sort((a, b) => b - a);
  const hasData = (ym) => periods.includes(ym);
  const sel = "h-9 border border-zinc-200 bg-white px-2 text-sm font-medium text-zinc-800 focus:outline-none focus:border-[#002FA7]";
  return (
    <div className="inline-flex items-center gap-1" data-testid={testid}>
      {!compact && <button type="button" onClick={() => onChange(shiftYm(value, -1))} className="h-9 w-9 border border-zinc-200 bg-white flex items-center justify-center hover:bg-zinc-50" data-testid={`${testid}-prev`} aria-label="Mes anterior"><CaretLeft size={14} weight="bold" /></button>}
      <select value={m} onChange={(e) => onChange(`${y}-${String(e.target.value).padStart(2, "0")}`)} className={`${sel} min-w-[130px]`} data-testid={`${testid}-month`}>
        {MONTHS_ES.map((label, i) => {
          const ym = `${y}-${String(i + 1).padStart(2, "0")}`;
          return <option key={i} value={i + 1}>{label}{hasData(ym) ? " •" : ""}</option>;
        })}
      </select>
      <select value={y} onChange={(e) => onChange(`${e.target.value}-${String(m).padStart(2, "0")}`)} className={sel} data-testid={`${testid}-year`}>
        {yearList.map((yy) => <option key={yy} value={yy}>{yy}</option>)}
      </select>
      {!compact && <button type="button" onClick={() => onChange(shiftYm(value, 1))} className="h-9 w-9 border border-zinc-200 bg-white flex items-center justify-center hover:bg-zinc-50" data-testid={`${testid}-next`} aria-label="Mes siguiente"><CaretRight size={14} weight="bold" /></button>}
    </div>
  );
}
